import React, { useState, useEffect } from "react";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import Button from "react-bootstrap/Button";
import { IconDeviceFloppy, IconSquareX } from "@tabler/icons-react";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const EditPpsComp = (props) => {
  // console.log(props);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [idSkorRs, setidSkorRs] = useState(props?.ubahItemPps?.idSkorRs);
  const [idSkorAkreditasi, setidSkorAkreditasi] = useState(
    props?.ubahItemPps?.idSkorAkreditasi
  );
  const [langkahPemenuhan, setlangkahPemenuhan] = useState(
    props?.ubahItemPps?.langkahPemenuhan
  );
  const [metodePerbaikan, setmetodePerbaikan] = useState(
    props?.ubahItemPps?.metodePerbaikan
  );
  const [indikatorPencapaian, setindikatorPencapaian] = useState(
    props?.ubahItemPps?.indikatorPencapaian
  );
  const [periodeAwal, setperiodeAwal] = useState(
    props?.ubahItemPps?.periodeAwal
  );
  const [periodeAkhir, setperiodeAkhir] = useState(
    props?.ubahItemPps?.periodeAkhir
  );
  const [kategoriPeriode, setkategoriPeriode] = useState(
    props?.ubahItemPps?.kategoriPeriode
  );
  const [pic, setpic] = useState(props?.ubahItemPps?.pic);
  const [keterangan, setketerangan] = useState(props?.ubahItemPps?.keterangan);
  const [catatan, setcatatan] = useState(props?.ubahItemPps?.catatan);
  const [kategoriPerbaikan, setkategoriPerbaikan] = useState(
    props?.ubahItemPps?.kategoriPerbaikan
  );
  const [jangkaWaktuPerbaikan, setjangkaWaktuPerbaikan] = useState(
    props?.ubahItemPps?.jangkaWaktuPerbaikan
  );

  const handleEditPps = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      idSkorRs: idSkorRs,
      idSkorAkreditasi: idSkorAkreditasi,
      langkahPemenuhan: langkahPemenuhan,
      metodePerbaikan: metodePerbaikan,
      indikatorPencapaian: indikatorPencapaian,
      periodeAwal: periodeAwal,
      periodeAkhir: periodeAkhir,
      kategoriPeriode: kategoriPeriode,
      pic: pic,
      keterangan: keterangan,
      catatan: catatan,
      kategoriPerbaikan: kategoriPerbaikan,
      jangkaWaktuPerbaikan: jangkaWaktuPerbaikan,
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: `/pps-item/update/${props?.ubahItemPps?.id}`,
      method: "PATCH",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res);
        // return false;
        if (res.status === 200) {
          MySwal.fire({
            icon: "success",
            title: "Success",
            text: "Successfully updated laporan!",
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: `${err?.response?.data?.message}`,
          });
        }
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="langkahPemenuhan" className="form-label required">
              Langkah Pemenuhan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="langkahPemenuhan"
              onChange={(e) => setlangkahPemenuhan(e.target.value)}
              value={langkahPemenuhan}
            ></textarea>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="metodePerbaikan" className="form-label required">
              Metode Perbaikan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="metodePerbaikan"
              onChange={(e) => setmetodePerbaikan(e.target.value)}
              value={metodePerbaikan}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label
              htmlFor="indikatorPencapaian"
              className="form-label required"
            >
              Indikator Pencapaian
            </label>
            <textarea
              className="form-control row-cols-3"
              id="indikatorPencapaian"
              onChange={(e) => setindikatorPencapaian(e.target.value)}
              value={indikatorPencapaian}
            ></textarea>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="keterangan" className="form-label">
              Keterangan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="keterangan"
              onChange={(e) => setketerangan(e.target.value)}
              value={keterangan}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="periodeAwal" className="form-label required">
              Periode Awal
            </label>
            <input
              type="date"
              className="form-control row-cols-3"
              id="periodeAwal"
              onChange={(e) => setperiodeAwal(e.target.value)}
              value={periodeAwal}
            ></input>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="periodeAkhir" className="form-label required">
              Periode Akhir
            </label>
            <input
              type="date"
              className="form-control row-cols-3"
              id="periodeAkhir"
              onChange={(e) => setperiodeAkhir(e.target.value)}
              value={periodeAkhir}
            ></input>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="kategoriPeriode" className="form-label required">
              Kategori Periode
            </label>
            <select
              className="form-select"
              id="kategoriPeriode"
              onChange={(e) => setkategoriPeriode(e.target.value)}
              value={kategoriPeriode}
              placeholder="Pilih Kategori Periode"
            >
              <option>Pilih Kategori Periode</option>
              <option value={"Semester 1"}>Semester 1</option>
              <option value={"Semester 2"}>Semester 2</option>
            </select>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="pic" className="form-label required">
              PIC
            </label>
            <input
              type="text"
              className="form-control row-cols-3"
              id="pic"
              onChange={(e) => setpic(e.target.value)}
              value={pic}
            ></input>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <div className="mb-5">
            <label htmlFor="kategoriPerbaikan" className="form-label required">
              Kategori Perbaikan
            </label>
            <select
              className="form-select"
              id="kategoriPerbaikan"
              onChange={(e) => setkategoriPerbaikan(e.target.value)}
              value={kategoriPerbaikan}
              placeholder="Pilih Jangka Waktu Perbaikan"
            >
              <option>Pilih Kategori Perbaikan</option>
              <option value={"Dokumen"}>Dokumen</option>
              <option value={"Proses"}>Proses</option>
            </select>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-5">
            <label
              htmlFor="jangkaWaktuPerbaikan"
              className="form-label required"
            >
              Jangka Waktu Perbaikan
            </label>
            <select
              className="form-select"
              id="jangkaWaktuPerbaikan"
              onChange={(e) => setjangkaWaktuPerbaikan(e.target.value)}
              value={jangkaWaktuPerbaikan}
              placeholder="Pilih Jangka Waktu Perbaikan"
            >
              <option>Pilih Jangka Waktu Perbaikan</option>
              <option value={1}>Kurang dari 3 Bulan</option>
              <option value={2}>Antara 3 - 6 Bulan</option>
              <option value={3}>Antara 6 - 9 Bulan</option>
              <option value={4}>Lebih dari 9 Bulan</option>
            </select>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="mb-5">
            <label htmlFor="catatan" className="form-label">
              Catatan
            </label>
            <textarea
              className="form-control row-cols-6"
              id="catatan"
              onChange={(e) => setcatatan(e.target.value)}
              value={catatan}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="mt-5 row">
        <div className="d-flex flex-center flex-row-fluid pt-2">
          <Button
            disabled={disabled}
            variant="primary"
            size="sm"
            onClick={() => handleEditPps()}
          >
            <IconDeviceFloppy stroke={2} />{" "}
            {loading === true ? "Mohon Tunggu.." : "Simpan"}
          </Button>
          &nbsp;
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            <IconSquareX stroke={2} /> Tutup
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditPpsComp;
